import React from "react";
import { useTranslation } from "react-i18next";
import { usePopup } from "@/context/PopupContext";
import styles from "./PricingTable.module.scss";

interface ServiceRow {
  name: string;
  price: string;
}

const PricingTable: React.FC = () => {
  const { t } = useTranslation("common");
  const { openMenu } = usePopup();

  const services = t("pricingTable.services", {
    returnObjects: true,
  }) as ServiceRow[];

  return (
    <div className="container section">
      <div className="sectionContainer sectionContainerWhite bigSection">
        <div className="sideP64 titleCont">
          <div className="titleBlock">
            <h2 className={styles.title}>{t("pricingTable.title")}</h2>
          </div>
          <button className="commonButton buttonLg" onClick={openMenu}>
            {t("pricingTable.button")}
          </button>
        </div>

        <div className={`${styles.tableWrap} sideP64`}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{t("pricingTable.colService")}</th>
                <th>{t("pricingTable.colPrice")}</th>
              </tr>
            </thead>
            <tbody>
              {services.map((row, i) => (
                <tr key={i}>
                  <td>{row.name}</td>
                  <td>{row.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className={`${styles.footer} sideP64`}>
          <p>{t("pricingTable.footer")}</p>
          <button className="commonButton buttonLg" onClick={openMenu}>
            {t("pricingTable.button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingTable;
